import { isSolidApplication } from '@tcc/i18n';
import { DisplayUnit, LocaleGroup } from '../types/Common';

export const getApplicationRateUnits = (unitKey: string): DisplayUnit =>
  isSolidApplication(unitKey)
    ? DisplayUnit.APPLICATION_RATE_BY_MASS
    : DisplayUnit.APPLICATION_RATE_BY_VOLUME;

export const getApplicationAmountAppliedUnits = (unitKey: string): DisplayUnit =>
  isSolidApplication(unitKey)
    ? DisplayUnit.APPLICATION_AMOUNT_BY_MASS
    : DisplayUnit.APPLICATION_AMOUNT_BY_VOLUME;

export function getApplicationLocaleGroup(unitKey: string): LocaleGroup {
  return isSolidApplication(unitKey)
    ? LocaleGroup.APPLICATION_DRY
    : LocaleGroup.APPLICATION_LIQUID;
}

export function getApplicationAmountLocaleGroup(unitKey: string): DisplayUnit {
  return isSolidApplication(unitKey)
    ? DisplayUnit.APPLICATION_AMOUNT_BY_MASS
    : DisplayUnit.APPLICATION_AMOUNT_BY_VOLUME;
}
